<template>
  <nav class="menu">
    <RouterLink to="/experience-dashboard">Your dashboard</RouterLink>
  </nav>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.menu > a {
  color: #3d3d3d;
  text-decoration: none;
  font-size: 2rem;
}
</style>
